import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { TablePagination } from '@mui/material';
import Actions from './Actions/Actions';
import ControlledTable from '../../../../shared/ui/ControlledTable/ControlledTable';
import { displayedCells, headCells } from '../constants/headCells';
import prepareAdviceRows from './utils/prepareAdviceRows';

function AdvicesTableWidget({ advices, count, rowsPerPage, page, onPageChange, onRowsPerPageChange }) {
  const rows = useMemo(() => prepareAdviceRows(advices), [advices]);

  return (
    <>
      <ControlledTable
        rows={rows}
        headCells={headCells}
        displayedCells={displayedCells}
        countRowsPerPage={rowsPerPage}
        selected={[]}
        setSelected={() => {}}
        disableCheckbox
        renderCustomControls={({ adviceId, cases }) => <Actions adviceId={adviceId} solutions={cases} />}
      />

      <TablePagination
        rowsPerPageOptions={[5, 15, 30]}
        component="div"
        count={count}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
      />
    </>
  );
}

AdvicesTableWidget.propTypes = {
  advices: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired,
  count: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onRowsPerPageChange: PropTypes.func.isRequired,
};

export default AdvicesTableWidget;
